import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpenIcon, BrainIcon, PhoneIcon, CalculatorIcon, ServerIcon, ArrowRightIcon } from 'lucide-react';
import { IncomeCalculator } from './IncomeCalculator';
import { TrustBadges } from './TrustBadges';
export function ValueStackV2() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);
  const items = [{
    icon: BookOpenIcon,
    title: 'EL MINI-CURSO "AI WEB CLOSER"',
    value: '$197',
    description: '4 módulos de acción rápida. Cada módulo tiene menos de 20 minutos. Puedes terminar el curso en una tarde y empezar a contactar clientes esa misma noche.',
    resultado: 'En una tarde terminas el curso y esa misma noche puedes contactar tu primer cliente.'
  }, {
    icon: BrainIcon,
    title: 'EL CEREBRO DE IA "LOCAL SCOUT"',
    value: '$197',
    description: 'La IA personalizada que encuentra negocios locales sin sitio web o con sitios obsoletos. Solo le dices la ciudad y el tipo de negocio. Ella hace el trabajo de investigación.',
    resultado: '10 prospectos listos para contactar en menos de 15 minutos.'
  }, {
    icon: BrainIcon,
    title: 'EL CEREBRO DE IA "WEB BUILDER"',
    value: '$197',
    description: 'La IA que construye el sitio web del cliente en minutos. Le das la información del negocio y ella genera una página profesional lista para presentar.',
    resultado: 'Una demo profesional lista para presentar antes de hacer la primera llamada.'
  }, {
    icon: PhoneIcon,
    title: 'EL GUION DE CIERRE "AI WEB CLOSER"',
    value: '$197',
    description: 'El guion exacto para llamar o escribirle al dueño del negocio y cerrar la venta. Incluye respuestas a las 5 objeciones más comunes.',
    resultado: 'Conviertes una conversación casual en una venta de $350 sin sonar como vendedor.'
  }, {
    icon: CalculatorIcon,
    title: 'LA CALCULADORA DE PRECIOS',
    value: '$27',
    description: 'Sabe exactamente cuánto cobrar según el tipo de negocio, la ciudad y los servicios incluidos.',
    resultado: 'Sabes exactamente cuánto cobrar para maximizar tu ganancia en cada nicho.'
  }, {
    icon: ServerIcon,
    title: 'EL SOFTWARE DE IA (HEYLLOYD)',
    value: 'Desde $20/mes',
    description: 'El software de IA que usarás para encontrar prospectos y construir demos. Tiene un plan desde $20/mes — menos de lo que cobras por un solo sitio web.',
    resultado: 'Se paga solo con tu primera venta.',
    isExternal: true
  }];
  return <section ref={ref} className="w-full py-20 px-4 bg-navy-light" data-id="element-716">
      <div className="max-w-6xl mx-auto" data-id="element-717">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-718">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl mb-4" data-id="element-719">
            Todo lo que Obtienes por <span className="text-gold" data-id="element-720">$27</span>
          </h2>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-721">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -50
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -50
          }} transition={{
            duration: 0.6,
            delay: 0.2 + index * 0.1
          }} className="bg-navy-dark border border-gold/20 rounded-xl p-6 md:p-8 hover:border-gold/40 transition-colors" data-id="element-722">
                <div className="flex flex-col md:flex-row md:items-start gap-6" data-id="element-723">
                  <div className="flex-shrink-0 w-16 h-16 bg-gold/20 rounded-xl flex items-center justify-center" data-id="element-724">
                    <Icon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-725" />
                  </div>

                  <div className="flex-1" data-id="element-726">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 mb-3" data-id="element-727">
                      <div className="flex items-center gap-3" data-id="element-728">
                        <h3 className="font-heading font-bold text-xl md:text-2xl" data-id="element-729">
                          {item.title}
                        </h3>
                        {item.isExternal && <span className="bg-gray-800 text-gray-400 text-[10px] font-bold px-2 py-1 rounded tracking-wider" data-id="element-730">
                            HERRAMIENTA EXTERNA
                          </span>}
                      </div>
                      <span className="font-heading font-bold text-lg text-gold" data-id="element-731">
                        {item.isExternal ? item.value : `(Valor: ${item.value})`}
                      </span>
                    </div>
                    <p className="font-body text-base text-gray-300 leading-relaxed mb-3" data-id="element-732">
                      {item.description}
                    </p>

                    <div className="font-body text-sm text-gold/80 mt-2 flex items-start gap-2 bg-gold/5 p-3 rounded-lg border border-gold/10" data-id="element-733">
                      <ArrowRightIcon className="h-4 w-4 mt-0.5 flex-shrink-0" data-id="element-734" />
                      <span className="font-semibold" data-id="element-735">Resultado:</span>{' '}
                      {item.resultado}
                    </div>

                    {index === 4 && <motion.button onClick={() => setIsCalculatorOpen(true)} whileHover={{
                  scale: 1.02
                }} whileTap={{
                  scale: 0.98
                }} className="mt-5 bg-gold/10 hover:bg-gold/20 border border-gold/30 hover:border-gold/50 text-gold font-heading font-bold text-sm px-6 py-3 rounded-lg transition-all inline-flex items-center gap-2" data-id="element-736">
                        <CalculatorIcon className="h-4 w-4" data-id="element-737" />
                        Ver Calculadora Interactiva
                      </motion.button>}
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.a href="/checkout-2" onClick={() => {
        if (window.fbq) window.fbq('track', 'AddToCart', {
          content_name: 'AI Web Closer Course',
          content_type: 'product',
          value: 27,
          currency: 'USD'
        });
      }} initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.9
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="block bg-gradient-to-r from-gold-dark via-gold to-gold-dark rounded-2xl p-8 text-center cursor-pointer no-underline transition-shadow hover:shadow-2xl hover:shadow-gold/30" data-id="element-738">
          <p className="font-heading font-bold text-2xl md:text-3xl text-navy mb-2" data-id="element-739">
            VALOR TOTAL: <span className="line-through opacity-70" data-id="element-740">$835</span>
          </p>
          <p className="font-heading font-black text-4xl md:text-5xl text-navy" data-id="element-741">
            TÚ PAGAS HOY: $27
          </p>
        </motion.a>

        <TrustBadges data-id="element-742" />
      </div>

      <IncomeCalculator isOpen={isCalculatorOpen} onClose={() => setIsCalculatorOpen(false)} data-id="element-743" />
    </section>;
}